import styled from 'styled-components';
import { COLORS, FONTS } from '@app/src/ui';
import { FieldGroup } from '@app/src/components/Field';

interface Props {
  show?: boolean;
  isAdmin: boolean;
}

export const FormWrapper = styled.form`
  width: 100%;
  margin-bottom: 30px;
`;

export const Content = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  padding: 0 16px;
  max-height: ${(props: Props) => props.isAdmin ? '190px' : '94px'};
  transition: all .4s ease;
  overflow: hidden;

  ${(props: Props) => props.show && `
    max-height: ${ props.isAdmin ? '570px' : '476px'};
    transition: all .4s ease;
  `}

  @media(min-width: 480px) {
    padding: 0;
  }

  @media(min-width: 960px) {
    flex-wrap: nowrap;
  }
`;

export const FieldWrapper = styled.div`
  display: flex;
  width: 100%;

  @media(min-width: 960px) {
    flex: 1;
    margin-right: 20px;

    &:last-child {
      margin: 0;
    }
  }
`;

export const FieldDate = styled(FieldGroup)`
  width: 100%;

  @media(min-width: 960px) {
    flex: 2;
    margin-right: 20px;
  }
`;

export const Footer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: black;
  padding: 0 16px;

  @media(min-width: 480px) {
    padding: 0;
  }
`;

export const More = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-decoration: underline;
  cursor: pointer;

  @media(min-width: 960px) {
    display: none;
  }
`;

export const Error = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 30px;
  font-size: 14px;
  font-family: ${FONTS.ROBOTO_REGULAR};
  color: ${COLORS.ERROR_RED};
  padding: 0 16px;

  @media(min-width: 480px) {
    padding: 0;
  }
`;

export const TooltipWrapper = styled.div`
  display: none;

  @media(min-width: 960px) {
    display: block;
  }
`;
